import { Checkbox } from 'antd';
import { CheckboxChangeEvent } from 'antd/es/checkbox';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { CatalogFormFieldEntity } from 'entities/CatalogFormField';
import { FieldsCatalogControllerStore } from 'stores/local/forms/EditFormStore/FieldsCatalogControllerStore';
import { translateApiValue } from 'utils/translateApiValue';

type CatalogItemCheckboxProps = {
  entity: CatalogFormFieldEntity;
  store: FieldsCatalogControllerStore;
};

const CatalogItemCheckbox: React.FC<CatalogItemCheckboxProps> = ({
  entity,
  store,
}) => {
  const handleChangeEvent = React.useCallback(
    (e: CheckboxChangeEvent) => {
      store.selectField(entity.id, e.target.checked);
    },
    [entity.id, store]
  );

  return (
    <Checkbox
      checked={store.isFieldSelected(entity.id)}
      disabled={entity.required}
      onChange={handleChangeEvent}
    >
      {translateApiValue(entity.label)}
    </Checkbox>
  );
};

export default observer(CatalogItemCheckbox);
